<template>
  <div class="container">
    <!-- 这个页面可以组件化 -->
    <a-tabs :active-key="tabKey" @change="tabChange">
      <a-tab-pane key="1" tab="企业积分管理">
        <div class="queryFrom">
          <div class="search-keyword">
            <a-input placeholder="企业名称" v-model="blurry" style="margin: 0 20px;" allowClear @pressEnter="blurrySearch" @change="resetHighFields">
              <a-icon slot="prefix" type="search" />
            </a-input>
            <a-button type="primary" icon="search" @click="blurrySearch">搜索</a-button>
          </div>
        </div>
        <div class="table">
          <a-table
            :columns="columns1"
            :dataSource="tableData1"
            :pagination="pagination1"
            @change="pagChange"
            :rowKey="record => record.id"
            :loading="loading"
            style="background:#fff;"
          >
            <template slot="companyName"></template>
            <template slot="userName"></template>
            <template slot="userPhones"></template>
            <template slot="allPoints"></template>
            <template slot="freezePoints" slot-scope="record">
              <span class="font-color-red">{{record}}</span>
            </template>
            <template slot="userPoints"></template>
            <template slot="allMoney"></template>
            <template slot="operation" slot-scope="record">
              <a-button @click="rechargeShow(record)"  type="link" style="padding:0;" >充值</a-button>&nbsp;
              <a-button @click="showDetails(record)"  type="link" style="padding:0;" >详情</a-button>
            </template>
          </a-table>
        </div>
        <a-modal :visible="rechargeVisible" :footer="null" title="充值" @cancel="closeVisible" :maskClosable='false' centered>
            <a-form :form="rechargeForm">
              <a-row type="flex" justify="center">
                <a-col :span="11">
                  <a-form-item   label="充值金额" colon >
                    <a-input type="Number" :min="0" oninput="if(value.length>10)value=value.slice(0,10)" v-decorator='["money",{rules: [{ required: true, message: "请输入充值金额"}]}]'  style="width: 135px"/>
                  </a-form-item>
                </a-col>
                <a-col :span="2">
                </a-col>
                <a-col :span="11">
                  <a-form-item   label="充值积分" colon >
                    <a-input type="Number" :min="0" oninput="if(value.length>10)value=value.slice(0,10)"  v-decorator='["points",{rules: [{ required: true,  message: "请输入充值积分"}]}]' style="width: 135px" />
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row type="flex" justify="center">
                <a-form-item  label="充值说明" colon >
                  <a-textarea
                    :auto-size="{ minRows: 2, maxRows: 3 }"
                    v-decorator='["explan",{rules: [{ required: true,message: "请输入充值说明"}]}]'
                    style="width: 390px"
                  />
                </a-form-item>
              </a-row>
              <a-form-item >
                <a-button type="primary" style="margin-right: 50px; background-color: #999; border-color: #999;" @click="closeVisible">取消</a-button>
                <a-button type="primary" @click="submitRecharge">确认</a-button>
              </a-form-item>
            </a-form>
        </a-modal>
      </a-tab-pane>
      <a-tab-pane key="2" tab="企业积分明细">
        <div class="queryFrom">
          <div class="search-keyword">
            <a-input placeholder="企业名称" v-model="blurry" style="margin: 0 20px;" allowClear @pressEnter="blurrySearch" @change="resetHighFields">
              <a-icon slot="prefix" type="search" style="color: rgba(0,0,0,.25)" />
            </a-input>
            <a-select v-model="state" placeholder="积分使用情况" allowClear @change="resetHighFields" style="width: 200px; margin-right: 15px">
                <a-select-option value="1">充值（人工）</a-select-option>
                <a-select-option value="0">使用</a-select-option>
                <a-select-option value="2">赠送</a-select-option>
            </a-select>
            <a-button type="primary" icon="search" @click="blurrySearch">搜索</a-button>
          </div>
          <div class="tool-btn">
            <a-button type="primary" icon="export" @click="pointsExport">导出</a-button>
          </div>
        </div>
        <div class="table">
          <a-table
            :columns="columns2"
            :dataSource="tableData2"
            :pagination="pagination2"
            @change="pagChange"
            :rowKey="record => record.id"
            :loading="loading"
            style="background:#fff;"
          >
            <template slot="companyName" slot-scope="record">
              <span >{{record.name}}</span>
            </template>
            <template slot="pointsState"></template>
            <template slot="pointsNum" slot-scope="record">
              <span :class="record.state === '使用' ? 'font-color-red' : 'font-color-2eaf39'">
                <i>{{record.state === '使用' ? '-' : '+'}}</i>{{record.pointsNum}}
              </span>
            </template>
            <template slot="money"></template>
            <template slot="operatorUser" slot-scope="record">
              <span>{{record.operatorUser.username}}</span>
            </template>
            <template slot="description" slot-scope="record">
              <p class="recharge-description" :title="record.description">{{record.description}}</p>
            </template>
            <template slot="orderInfo" slot-scope="record">
              <a-button type="link" @click="goOrderDetail(record.labOrderId)">{{record.orderInfo}}</a-button>
            </template>
            <template slot="operatorTime" slot-scope="record">
              <span>{{record.operatorTime | formatDateTime}}</span>
            </template>
          </a-table>
        </div>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>


<script>
import {getAllPoints, addPoints, getPointsDetail, pointsExport} from "@/api/pointsManagement"
import {formatDate, dateDiff} from '../../utils/date';
import moment from 'moment';
import {
   deptManage, //基本列表
   adminDisable, //启用状态
   adminMediation,  //中介状态
   allRoles,
   } from "@/api/user"
const align= 'center'
const columns1 = [
  {
    title: '序号',
    dataIndex: "No",
    align,
    // customRender: (text, record, index) => `${index + 1}` // 显示每一行的序号
  },
  {
    title: "企业名称",
    dataIndex: "name",
    scopedSlots: { customRender: 'companyName' },
    align
  },
  {
    title: "联系人",
    dataIndex: "userName",
    scopedSlots: { customRender: 'userName' },
    align
  },
  {
    title: "联系方式",
    dataIndex: "phone",
    scopedSlots: { customRender: 'userPhones' },
    align
  },
  {
    title: "当前总积分",
    dataIndex: "allPints",
    scopedSlots: { customRender: 'allPoints' },
    align
  },
  {
    title: "已冻结积分",
    dataIndex: "freezePoints",
    scopedSlots: { customRender: 'freezePoints' },
    align
  },
  {
    title: "已使用积分",
    dataIndex: "usePoints",
    scopedSlots: { customRender: 'usePoints' },
    align
  },
  {
    title: "总计充值金额",
    dataIndex: "allMoney",
    scopedSlots: { customRender: 'allMoney' },
    align
  },
  {
    title: "操作",
    scopedSlots: { customRender: 'operation' },
    align
  },
];
const columns2 = [
  {
    title: '序号',
    dataIndex: 'No',
    align,
    // customRender: (text, record, index) => `${index + 1}` // 显示每一行的序号
  },
  {
    title: "企业名称",
    // dataIndex: "name",
    scopedSlots: { customRender: 'companyName' },
    align,
    width: 250,
  },
  {
    title: "积分使用情况",
    dataIndex: "state",
    scopedSlots: { customRender: 'state' },
    
    align
  },
  {
    title: "积分",
    // dataIndex: "pointsNum",
    scopedSlots: { customRender: 'pointsNum' },
    align
  },
  {
    title: "金额",
    dataIndex: "money",
    scopedSlots: { customRender: 'money' },
    align
  },
  {
    title: "操作人",
    // dataIndex: "operatorUser",
    scopedSlots: { customRender: 'operatorUser' },
    align
  },
  {
    title: "充值说明",
    // dataIndex: "description",
    scopedSlots: { customRender: 'description' },
    align,
    width: 350,
  },
  {
    title: "相关订单",
    // dataIndex: "operatingTime",
    scopedSlots: { customRender: 'orderInfo' },
    align
  },
  {
    title: "操作时间",
    // dataIndex: "operatingTime",
    scopedSlots: { customRender: 'operatorTime' },
    align,
    width: 180,
  },
];

export default {
  name: 'pointsManagement',
  data() {
    return {
      id:0,
      tabKey: "1",
      rechargeForm: this.$form.createForm(this),
      columns1,
      columns2,
      tableData1:[],
      tableData2:[],
      loading:false,
      rechargeVisible:false,

      blurry:'',
      pagination1:{
        showSizeChanger:true,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: total => `共 ${total} 条记录`,
        showSizeChange:(current, pageSize) => {
          this.pageSize = pageSize
        }
      },
      pagination2:{
        showSizeChanger:true,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: total => `共 ${total} 条记录`,
        showSizeChange:(current, pageSize) => {
          this.pageSize = pageSize
        }
      },
      state: undefined, // 积分使用情况，积分明细列表的查询调条件
      // sortType: '',
      sortBy: '',
      isFilter1: false,
      isFilter2: false,
      exportStatus: true, // 是否可以导出
    }
  },
  mounted() {
    this.getAllPoints();
  },
  methods: {
    goOrderDetail(id) {
      this.$store.dispatch('menus/addActiveUrls', 'pointsManagement').then(() => {
          setTimeout(() => {
            this.$router.push({path: '/detection/orderDetail', query: {'id': id}});
          }, 500);
      })
    },
    pointsExport() {
      if (this.exportStatus) {
        this.exportStatus = false;
        let params = {
          blurry: this.blurry
        };
        this.$message.success('拼命导出中，请稍后...');
        pointsExport(params)
        .then(res => {
          const blob = new Blob([res], {type: "application/vnd.ms-excel"});
          const fileName = '积分明细导出数据.xls';
          if ('download' in document.createElement('a')) {
            const link = document.createElement('a')
            link.download = fileName;
            link.style.display = 'none';
            link.href = URL.createObjectURL(blob);
            document.body.appendChild(link);
            link.click();
            URL.revokeObjectURL(link.href);
            document.body.removeChild(link);
          } else {
            navigator.msSaveBlob(blob, fileName);
          }
          setTimeout(() => {
            this.exportStatus = true;
          }, 1000);
        })
        .catch(err => {
          this.exportStatus = true;
          console.log(err);
        })
      } else {
        this.$message.warning('正在导出中，请勿重复操作');
      }
    },
    // 获取积分列表
    getAllPoints() {
      let params = {
        page: this.pagination1.current -1,
        size: this.pagination1.pageSize,
        blurry: this.blurry,
      }
      this.loading = true;
      getAllPoints(params)
        .then(res=>{
          this.tableData1 = res.content;
          for(let i=0; i<this.tableData1.length; i++) {
            this.tableData1[i].No = (this.pagination1.current - 1) * this.pagination1.pageSize + i + 1
          }
          this.pagination1.total = res.totalElements;
          this.loading = false;
        })
        .catch(error=>{
          this.loading = false;
          console.log(error);
        })
    },
    // 充值
    addPoints(params) {
      addPoints(params) 
        .then(res => {
          this.rechargeForm.resetFields();
          this.getAllPoints();
          this.$message.success('充值成功');
        })
        .catch(error => {
          console.log(error);
        })
    },
    // 获取积分细明列表
    getPointsDetail() {
      this.loading = true;
       let params = {
        page: this.pagination2.current -1,
        size: this.pagination2.pageSize,
        state: this.state,
        blurry: this.blurry,
      }
      getPointsDetail(params)
        .then(res=>{
          
          this.tableData2 = res.content;
          for(let i=0; i<this.tableData2.length; i++) {
            this.tableData2[i].No = (this.pagination2.current - 1) * this.pagination2.pageSize + i + 1
          }
          this.pagination2.total = res.totalElements;
          this.loading = false;
        })
        .catch(error=>{
          this.loading = false;
          console.log(error);
        })
    },
    // 切换 tab 
    tabChange(key) {
      this.tabKey = key;
      key === '2' ? this.getPointsDetail() : this.getAllPoints();
    },
    // 模糊搜索
    blurrySearch(){
      this.loading = true;
      if(this.tabKey ===  "2"){
        this.pagination2.current = 1;
        this.isFilter2 = true;
        this.getPointsDetail();
      }else {
        this.pagination1.current = 1;
        this.isFilter1 = true;
        this.getAllPoints();
      }
    },
    // 重置搜索 
    resetHighFields(){
      console.log('sdf');
      this.loading = true;
      if(this.tabKey ===  "2"){
        this.pagination2.current = 1;
        this.getPointsDetail();
        this.isFilter2 = false;
      }else {
        this.pagination1.current = 1;
        this.getAllPoints();
        this.isFilter1 = false;
      }
    },
    // 充值
    rechargeShow(row){
      this.rechargeVisible = true;
      this.id = row.id;
    },
    // 提交充值表单
    submitRecharge(e){
      e.preventDefault();
      this.rechargeForm.validateFields((error, values) => {
        if(!error) {
          let params = {
            id: Number(this.id),
            points: Number(values.points),
            money: Number(values.money),
            explan: values.explan
          }
          if(params.points<0 || params.points%1 !== 0 || params.money<0 ||params.money%1 !== 0) {
            this.$message.error('充值失败：金额或积分格式不正确');
            return;
          }
          this.rechargeVisible = false;
          this.addPoints(params);
        }
      });
    },
    // 显示详情
    showDetails(row){
      this.blurry = row.name;
      this.tabChange("2");
      this.getPointsDetail();
    },
    // 关闭弹出框
    closeVisible() {
      this.rechargeVisible = false;
      this.rechargeForm.resetFields(); // 移出未输入的提示
    },
    /*** 翻页 */
    pagChange(pagination, filters, sorter){
      if(this.tabKey ===  "2") {
        this.pagination2.current = pagination.current;
        this.pagination2.pageSize = pagination.pageSize;
        this.getPointsDetail();
      }else{
        this.pagination1.current = pagination.current;
        this.pagination1.pageSize = pagination.pageSize;
        this.getAllPoints();
      }
      
    },
  },
  filters: {
    formatDateTime(time) {
      if (time) {
          let date = new Date(time);
          return formatDate(date, "yyyy-MM-dd hh:mm:ss");
        } else {
          return '';
        }
    },
  },
}

</script>
<style lang="less" scoped>
.green {
  color: #67C23A;
}
.red {
  color: #F56C6C;
}
.ant-form-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
  }
  .container{
    min-height: 100%;
    // background-color: #fff;
    // padding: 15px;
    .queryFrom{
      margin-bottom: 15px;
      background-color: #fff;
      overflow: hidden;
      padding: 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .search-keyword {
        flex: 1;
        position: relative;
        margin: 8px 20px  8px 0;
        align-items: center;
        .ant-input-affix-wrapper {
          margin-right: 10px;
          max-width: 380px;
        }
      }
      .tool-btn{
        margin-left: 20px;
      }
    }
    .btnTag{
      height:32px;
      line-height: 32px;
      font-size: 14px;
      border-radius: 4px;
      margin-right:5px;
      p{
        line-height: 32px;
      }
    }
  }
  // 
.font-color-red {
  color: red;
}
.font-color-2eaf39 {
  color: #2eaf39;
}
.recharge-description {
  width: 350px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
/deep/.ant-input-lg {
  height: 32px;
  font-size: 14px;
}
/deep/.ant-btn-lg {
  height: 32px;
  font-size: 14px;
}
</style>
<style>
.ant-tabs-bar {
    margin: 0!important;
    background-color: #fff;
    border-bottom: 1px solid #ccc;
}
</style>
